<template>
  <div class="new-home-con">
    <div class="el-carousel__item u070db_4"></div>
    <div class="new-home-wrap">
      <Hearder></Hearder>
      <div class="new-home-search">
        <div class="new-search-country-con">
          <div id="gc1d8d" class="new-search-country-con-Home">
            <div
              class="country-dropdown"
              @click.stop="isCountryShow = !isCountryShow"
            >
              <span class="select-country-con">
                <template
                  v-if="
                    selectCountryObj.countryCode == null ||
                    selectCountryObj.countryCode == '' ||
                    selectCountryObj.countryCode == 'undefined'
                  "
                >
                  <span class="country-placeholder">{{
                    $t("Home.selectCountry")
                  }}</span>
                </template>
                <template v-else>
                  <img
                    :src="selectCountryObj.urlBanner"
                    class="select-country-img"
                  />
                  <span class="select-country-name">{{
                    selectCountryObj.nameEn
                  }}</span>
                </template>
                <i
                  class="iconfont icon-jiantouxia"
                  :class="{ 'country-arrow': isCountryShow }"
                ></i>
              </span>
            </div>
            <div
              ref="countryRef"
              class="country-popper"
              :class="{ 'country-show-popper': isCountryShow }"
            >
              <div class="country-popper-arrow"></div>
              <div class="country-popper-con">
                <div class="state-con">
                  <div
                    class="country-state-item"
                    :class="{ activeState: selectStateIndex == index }"
                    v-for="(item, index) in stateList"
                    :key="index"
                    @click="onChangeState(index)"
                  >
                    <span class="country-name">{{
                      item.continent.enName
                    }}</span>
                    <span class="country-countryCount">{{
                      item.continent.countryNumStr
                    }}</span>
                  </div>
                </div>
                <div class="state-country-con">
                  <div
                    class="state-country-item"
                    v-for="(item, index) in stateCountryList"
                    :key="index"
                    :class="{
                      activeCountry:
                        selectCountryObj.countryCode == item.countryCode,
                    }"
                    @click="selectCountryObjFn(item)"
                  >
                    <div class="state-country-item-con">
                      <img :src="item.urlBanner" />
                      <div class="state-country-info">
                        <div class="state-country-name">{{ item.nameEn }}</div>
                        <div class="state-country-companyCount">
                          {{ item.companyNumStr }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="g3a94b" class="search-country-input-box">
              <el-input
                id="c308fb"
                v-model="searchStr"
                class="search-country-input"
                @keydown.native="
                  (e) => {
                    if (e.key === 'Enter' && !e.isComposing)
                      openList(searchStr);
                  }
                "
                :placeholder="$t('Home.inputCompany')"
                size="large"
              >
              </el-input>
            </div>
            <div class="head_swi_keyword">
              <el-switch
                v-model="Keyword"
                active-color="#1290C9 "
                inactive-color="#1290C9"
                @change="switchHeadKeyword"
              ></el-switch>
              <span v-if="Keyword == true" class="switch_txt">{{
                $t("Home.keWord")
              }}</span>
              <span v-else class="switch_txt">{{ $t("Home.firstWord") }}</span>
            </div>

            <el-button
              type="primary"
              round
              @click="openList(searchStr)"
              class="search-country-btn RiskBack"
              ><i class="iconfont icon-search"></i>
              {{ $t("Home.search") }}</el-button
            >
          </div>
        </div>
        <div class="new-home-search-text">
          {{ $t("Home.searchCompanyNum") }}
        </div>
      </div>
      <!-- 新闻推荐 -->
      <Newsrecommendation></Newsrecommendation>
    </div>
  </div>
</template>
<script>
import {
  getqueryList,
  getNotificationList,
  markAllAsRead,
  getqueryaddList,
  getqueryremoveList,
  companyView,
} from "@/api/userApi";
import { LoginOut } from "@/api/api.js";
import bus from "../../components/bus";
import Login from "../../components/login.vue";
import Perfectdata from "../../components/PerfectData.vue";
import gui_card from "../../components/gui_card/gui_card.vue";
import { mixins1 } from "../../mixins/index";
import gui_chart from "../../components/gui_chart/gui_chart.vue";
import Hearder from "../newLayout/header.vue";
import Newsrecommendation from "./Newsrecommendation.vue";
//importEnd
import { getCountryCollection, getUserSimpleInfo } from "@/api/companyApi.js";
import {
  searchCompany,
  productSearch,
  searchTradeHscode,
} from "@/api/searchApi.js";
import RouterDrawe from "../../components/router-drawer/drawer.vue";
import OperationWarning from "@/components/power/OperationWarning.vue";
import { mapGetters } from "vuex";
export default {
  mixins: [mixins1],
  name: "",
  props: {},

  components: {
    Hearder,
    gui_chart,
    Login,
    gui_card,
    Perfectdata,
    RouterDrawe,
    OperationWarning,
    Newsrecommendation,
  },
  created() {
    //登陆状态
    this.token ? (this.loginStatus = true) : (this.loginStatus = false);
    //登陆状态
    bus.$on("handleLogin", (loginCheck) => {
      // location.reload();
      this.loginStatus = loginCheck;
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.imageUrl =
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
            JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg;
      this.getUserSimpleInfoList();
      this.getqueryListDetale();
      this.getNotificationListDetali();
    });
    if (this.token) {
      this.companyViewPower();

      this.getUserSimpleInfoList();
      this.getqueryListDetale();
      this.getNotificationListDetali();
      this.imageUrl =
        JSON.parse(localStorage.getItem("userInfoImg")) == undefined
          ? this.imageUrl
          : JSON.parse(localStorage.getItem("userInfoImg"));
    }
  },
  mounted() {
    this.getCountryList();
    this.selectLanguage({ countryCode: this.$store.state.app.lang });
    this.$i18n.locale = this.$store.state.app.lang;
    this.$store.dispatch("app/setLang", this.$i18n.locale);
    document.querySelector("html").classList.add("html-new-page");
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  data() {
    return {
      Keyword: true,
      drawer: false,
      hasPrivilege: false,
      items: [1, 2, 3, 4, 5],
      activeIndex: 0,
      swiperOption: {
        slidesPerView: 10,
        centeredSlides: true,
        //居中幻灯片无缺口。当你通过设置 centeredSlides: true 使得幻灯片居中后，
        centeredSlidesBounds: true,
        normalizeSlideIndex: false,

        direction: "vertical",
        spaceBetween: 0,
        // 滑动速度
        speed: 800,
        autoplay: {
          //自动开始
          delay: 3000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        // 无限循环
        loop: true,
        observer: false,
        observeParents: false,
      },
      Newlist: [],
      RedNews: [],
      ExpireDate: "",
      Vips: [],
      searchStr: "",
      AvailablePoints: 0,
      lockType: 0,
      percentage: 0,

      // isShowChannel
      isShowChannel: false,
      tradeSelect: "HsCode",
      placeholder: "Enter company name",
      tabCountryList: [],
      isCountryShow: false,
      selectStateIndex: 0,
      selectCountryObj: {
        countryCode: "",
      },
      stateList: [],
      stateCountryList: [],
      stateCountryListCopy: [],
      countryCode: "",
      countryName: "", //选中国家
      tabActiveName: "", //选择的区域
      placeholderTrade: "Search by",
      headPortrait: false,
      languageList: [
        {
          countryCode: "en",
          countryCodeImg: "GB",
          countryName: "English",
          color: true,
        },
        {
          countryCode: "jp",
          countryCodeImg: "JP",
          countryName: "Japanese",
          color: false,
        },
        {
          countryCode: "de",
          countryCodeImg: "DE",
          countryName: "German",
        },
        {
          countryCode: "fr",
          countryCodeImg: "FR",
          countryName: "France",
        },

        {
          countryCode: "es",
          countryCodeImg: "ES",
          countryName: "Spain",
        },
        {
          countryCode: "it",
          countryCodeImg: "IT",
          countryName: "Italy",
        },
        {
          countryCode: "nl",
          countryCodeImg: "NL",
          countryName: "Netherlands",
        },
        {
          countryCode: "pt",
          countryCodeImg: "PT",
          countryName: "Portugal",
        },
      ],
      // existingList
      existingList: [],
      // paidList
      paidList: [],
      // followingName
      followingName: "explore",
      // favoritesList
      favoritesList: [
        {
          name: "By letter",
          id: "blet",
          isActive: false,
        },
        {
          name: "By size",
          id: "bsz",
          isActive: false,
        },
        {
          name: "By category",
          id: "bct",
          isActive: true,
        },
        {
          name: "By date",
          id: "bd",
          isActive: false,
        },
        {
          name: "By status",
          id: "bst",
          isActive: false,
        },
      ],
      // activeFavoritesId
      activeFavoritesId: "",
      //
      isShowChat: false,
      loginDialog: false, //登录弹框
      loginStatus: false, //登录状态,
      Perfectdatalog: false, //收集信息
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
      token: localStorage.getItem("token"),
      userRole: {},
      percentageerr: false,

      moreclose: false,
      restaurants: [],
      state: "",
      timeout: null,
      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
            JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,

      // srcviewshomeindexvueDataEnd
    };
  },
  methods: {
    handleClickOutside(event) {
      let countryRef = this.$refs.countryRef;
      if (countryRef && !countryRef.contains(event.target)) {
        this.isCountryShow = false;
      }
    },
    selectLanguage(item) {
      this.languageList.map((ite) => {
        if (ite.countryCode == item.countryCode) {
          ite.color = true;
        } else {
          ite.color = false;
        }
      });
      this.$i18n.locale = item.countryCode;
      sessionStorage.setItem("language", this.$i18n.locale);

      this.$store.dispatch("app/setLang", this.$i18n.locale);
    },
    companyViewPower() {
      companyView({}).then((res) => {
        if (!res.data) {
          this.$store.dispatch("app/SetOperationWarning", true);
          // this.$bus.$emit('show-OperationWaring-dialog', '');
        }
      });
    },
    OperationWarningShow() {
      this.$bus.$emit("show-OperationWaring-dialog", "");
    },
    // 九宫格
    clossuoDialog(value) {
      this.drawer = value;
    },
    gotccsibizinfo(value) {
      window.open(value, "_blank");
    },
    // onSlideChange($event) {
    // },
    beforeEnter(el) {
      el.classList.add("active");
    },
    leave(el) {
      el.classList.remove("active");
    },
    labelClick(label) {
      this.countryName = label;
    },

    selectCountry(val) {
      let countryImg = this.getCountryImgUrl(val);
      let flag = require("../../../static" + countryImg);
      this.countryImg = flag;
      this.countryCode = val;

      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == val) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
    },
    //切换keyword
    switchHeadKeyword() {
      this.isKeyword != this.isKeyword;
    },

    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },

    gotomessage(item) {
      this.$router.push({
        path: "/account/Notifications",
        query: {
          id: item.id,
        },
      });
    },
    isShowChannelmethad() {
      this.isShowChannel = true;
    },
    //   获取国家列表
    async getCountryList() {
      if (localStorage.getItem("countryList")) {
        this.setCountryImg();
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
      } else {
        let res = await getCountryCollection();
        if (res && res.code) {
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList"),
          );
          localStorage.setItem("countryList", JSON.stringify(res.data.rows));

          this.setCountryImg();
          this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        }
      }
    },
    //   设置国家图片
    setCountryImg() {
      this.stateList = JSON.parse(localStorage.getItem("countryList"));
      this.stateList.map((item) => {
        item.countryList.map((itemC) => {
          if (itemC.urlBanner == null) {
            itemC.urlBanner = require("../../../static/imagev2/zanwutupian.png");
          } else {
            let getImageUrlPath = itemC.urlBanner.split("/static")[1];
            itemC.urlBanner = require("../../../static" + getImageUrlPath);
          }
        });
      });

      this.stateCountryList = this.stateList[0].countryList;
      // 信息参数不为空时赋值
      if (
        this.countryCode != "" &&
        this.countryCode != null &&
        this.countryCode != "undefined"
      ) {
        if (this.$route.meta.title == "NewsList") {
          this.selectCountryObj = this.stateCountryList.filter(
            (item) => item.countryCode == this.countryCode,
          )[0];
        } else {
          let filterData = this.sanctionList.filter(
            (item) => item.dictDataCode == this.countryCode,
          )[0];
          this.selectSanctionObj = {
            sanctionCode: filterData.dictDataCode,
            sanctionName: filterData.dictDataName,
          };
        }
      }
    },
    // 切换州
    onChangeState(index) {
      this.selectStateIndex = index;
      this.stateCountryList = this.stateList[index].countryList;
    },
    // 选择国家
    selectCountryObjFn(ite) {
      this.selectCountryObj = ite;
      this.countryCode = ite.countryCode;
      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == ite.countryCode) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
      this.isCountryShow = false;
    },
    AIseach() {
      if (this.loginStatus) {
        if (this.lockType == 2 || this.lockType == 3) {
          this.isShowChat = !this.isShowChat;
        } else {
          this.hasPrivilege = true;
        }
      } else {
        this.loginDialog = true;
      }
    },
    chasPrivilegeDialog() {
      this.hasPrivilege = false;
    },
    hide(value) {
      this.isShowChat = value;
    },
    MarkRead() {
      markAllAsRead().then((res) => {
        if (res.code == 200) {
          this.getNotificationListDetali();
          this.RedNews.length = 0;
        }
      });
    },

    // 信息获取
    getNotificationListDetali() {
      getNotificationList().then((res) => {
        if (res.code == 200) {
          this.Newlist = res.data;
          if (this.Newlist.length > 0) {
            res.data.map((item) => {
              if (item.hasRead == 0) {
                this.RedNews.push(item);
              }
            });
          }
        } else {
          this.Newlist = [];
        }
      });
    },
    // 积分获取
    getUserSimpleInfoList() {
      getUserSimpleInfo().then((res) => {
        if (res.code == 200) {
          if (res.data.certification != 1) {
            localStorage.setItem("renzheng", true);
          }
          this.AvailablePoints = res.data.availablePoints;
          this.ExpireDate = res.data.expiration;
          this.Vips = res.data.vips;
          this.lockType = res.data.lockType;
          this.$store.dispatch("app/setEquityType", res.data.availablePoints);
        }
      });
    },
    getqueryListDetale() {
      getqueryList().then((res) => {
        if (res.code == 200) {
          let showList = [];
          let showListtwo = [];
          res.data.forEach((item) => {
            showList.push({
              id: item.moduleId,
              name: item.screenName,
              type: item.screenName,
              isSelect: item.isShow,
              icon: item.icon,
            });
            if (item.isShow == true) {
              showListtwo.push({
                id: item.moduleId,
                name: item.screenName,
                type: item.screenName,
                isSelect: item.isShow,
                icon: item.icon,
              });
            }
          });
          this.existingList = showList;

          this.paidList = showListtwo;
        }
      });
    },

    gotoUSer(route) {
      this.$router.push({
        path: route,
      });
    },
    // insertMethod
    // srcviewshomeindexvueMethodStart
    // default
    Sign() {
      this.loginDialog = true;
    },

    default() {}, // 跳转搜索列表页面
    openList(str) {
      this.$store.dispatch("app/SetlabelCode", "");
      this.$store.dispatch("app/SetlabelCodeName", "");
      let Keyword = "";

      if (this.Keyword) {
        Keyword = 2;
      } else {
        Keyword = 1;
      }
      if (str) {
        this.$store.commit("setRefreshKey", new Date().getTime());
        this.$router.push({
          path: "/index/search/list/" + str + "/company",
          query: {
            searchname: str,
            companyCountry: this.countryCode,
            keword: Keyword,
          },
        });
      } else {
        // this.$router.push({
        //   path: "index/list/company",
        // });
      }
    }, // deleteTool
    deleteTool(item) {
      let index = this.existingList.findIndex((item2) => item2.id == item.id);
      let paidListindex = this.paidList.findIndex(
        (item3) => item3.id == item.id,
      );

      this.existingList[index].isSelect = false;

      if (index !== -1) {
        getqueryremoveList({
          moduleId: item.id,
        }).then((res) => {});
        this.paidList.splice(paidListindex, 1);
      }
      // item.isSelect = false;
    }, // addTool
    addTool(item) {
      let obj = this.existingList.find((item2) => item2.id == item.id);
      if (item.isSelect == false) {
        item.isSelect = true;
        getqueryaddList({
          moduleId: item.id,
        }).then((res) => {});
        this.paidList.push(JSON.parse(JSON.stringify(item)));
      }
    }, // taggleFlolwing
    taggleFlolwing(name) {
      this.followingName = name;
    },
    //Sign out 登出
    signOutAccount() {
      LoginOut({}).then((res) => {
        if (res.code == "200") {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });

          bus.$off("handleLogin");
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          location.reload();
          // window.location.href = "/";
          localStorage.removeItem("userInfoImg");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("dataCleaningField");
        } else {
          sessionStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("userInfoImg");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("dataCleaningField");
          location.reload();
          // window.location.href = "/";
        }
      });
    },

    gotoOne(value) {
      window.open(value, "_blank");
    },
    goHome() {
      this.$router.push("/");
    },
    // srcviewshomeindexvueMethodEnd
  },

  computed: {
    ...mapGetters({
      lang: "app/lang",
    }),
    classOption() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        // limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>

<style scoped>
.new-home-con .el-carousel {
  height: 100%;
}

.new-home-con >>> .el-carousel__container {
  height: 100%;
}

.new-home-con >>> .el-carousel__item {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.new-home-con >>> .el-carousel__indicators--horizontal {
  display: flex;
  align-items: center;
  height: 8px;
  bottom: 3%;
}

.new-home-con >>> .el-carousel__indicator {
  padding: 0;
}

.new-home-con >>> .el-carousel__indicator:not(:last-child) {
  margin-right: 6px;
}

.new-home-con >>> .el-carousel__button {
  width: 8px;
  height: 8px;
  opacity: 1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.51);
}

.new-home-con >>> .el-carousel__indicator.is-active .el-carousel__button {
  background: rgba(255, 255, 255, 1);
}

.new-home-con .new-home-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 7vh);
  z-index: 2;
}

.new-home-search-text {
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  line-height: 30px;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.8);
  text-align: center;
}

.new-home-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 82.709%;
}

.new-home-title {
  width: calc(100% - 40px);
  height: 88px;
  margin: 0 auto;
  line-height: 88px;
  padding-left: 20px;
  font-weight: 400;
  font-size: 34px;
  color: #ffffff;
  text-shadow: 0px 2px 2px rgba(6, 59, 64, 0.5);
  background: rgba(105, 128, 146, 0.45);
  border-radius: 6px;
  backdrop-filter: blur(8px);
}

.new-home-bottom-card {
  display: flex;
  height: 352px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
}

.new-home-card-left,
.new-home-card-middle {
  flex: 1;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.new-home-card-left {
  position: relative;
  padding-left: 50px;
  background: #1290c9;
}

.new-home-card-left img {
  position: absolute;
  top: 110px;
  left: 14px;
  width: 22px;
  height: 16px;
}

.new-home-card-left .slider-box {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.new-home-card-left .slider-con {
  display: flex;
  flex-direction: column;
  /* 内容排列为竖直方向 */
  padding-top: 14px;
  animation: scrollTop 25s linear infinite;
  will-change: transform;
}

@keyframes scrollTop {
  0% {
    transform: translateY(0);
    /* 初始位置 */
  }

  100% {
    transform: translateY(-47%);
  }
}

.new-home-card-left .slider-item {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  font-weight: bold;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.4);
  transition: 0.5s ease-in-out !important;
  cursor: pointer;
}

.new-home-card-left .slider-item.active {
  font-size: 24px;
  color: #ffffff;
}

.new-home-card-left .slider-item:not(:last-child) {
  margin-bottom: 2px;
}

.new-home-card-middle {
  position: relative;
  margin: 0 14px;
  background-position: left center;
  background-size: cover;
  overflow: hidden;
}

.new-home-middle-img {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate3d(-42%, 0%, 0);
  max-width: none;
  width: 703px;
  height: 399px;
  background-position: center center;
  background-size: cover;
  /* will-change: transform; */
  animation: scrollImg 12s linear infinite alternate;
}

@keyframes scrollImg {
  0% {
    transform: translate3d(-42%, 0%, 0);
  }

  50% {
    transform: translate3d(-50%, 0%, 0);
  }

  100% {
    transform: translate3d(-58%, 0%, 0);
  }
}

.new-home-middle-text {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 30px 20px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
  text-align: justify;
  cursor: pointer;
}

.new-home-middle-text:hover {
  text-decoration: underline;
}

.new-home-card-right {
  width: 300px;
  padding: 40px 10px 0 10px;
  background: #f5f5f5;
  border-radius: 12px;
}

.new-home-right-img {
  width: 120px;
  height: 120px;
  padding: 3px;
  margin: 0 auto 16px auto;
  background: #ffffff;
}

.new-home-right-text {
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: center;
}

.new-search-country-con-Home {
  display: flex;
  align-items: center;
  width: 100%;
}

.sel_value {
  width: 4.571428571428571rem;
  font-size: 1rem;
  word-break: break-all;
}

::v-deep .el-tabs--left .el-tabs__nav-wrap.is-left::after {
  width: 1px;
  background-color: #ddd;
}

.el-select-dropdown__item:hover {
  background: #f5f5f5;
}

.search-country-input-box {
  flex: 1;
}

.search-country-input {
  padding: 0 20px;
}

.search-country-input >>> .el-input__inner {
  line-height: 70px;
  font-size: 16px;
  padding: 0 0 0 10px !important;
  color: #1a2332;
  border: none !important;
  border-radius: 0;
}

.search-country-input >>> .el-input__inner::placeholder {
  font-weight: 400;
  color: #999;
}

.search-country-btn {
  position: relative;
  left: 1px;
  display: flex;
  align-items: center;
  width: 150px;
  height: 70px;
  font-size: 18px;
  color: #ffffff;
  background: #1290c9;
  border-radius: 0px 35px 35px 0px;
}

.search-country-btn >>> span {
  display: flex;
  align-items: center;
}

.search-country-btn i {
  font-size: 40px;
}

.select-country-con {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 10px 0 20px;
  cursor: pointer;
}

.select-country-con .country-placeholder {
  flex: 1;
  font-size: 16px;
}

.select-country-con i {
  font-size: 12px;
  color: #1a2332;
  transition: all 0.3s;
}

.search-country-input >>> .el-input__inner {
  padding: 0 0 0 20px !important;
}

.u070db_3 {
  background: url("../../assets/images/0-2Trame.jpg") no-repeat;
}

.u070db_4 {
  background: url("../../assets/images/0-5home.jpg") no-repeat;
}

.u070db_5 {
  background: url("../../assets/images/0-4home.jpg") no-repeat;
}

.NewsBack {
  background-color: #009ea7 !important;
}

.RiskBack {
  background-color: #1290c9 !important;
}
.country-dropdown {
  position: relative;
  width: 210px;
  min-width: 210px;
  border-radius: 27px 0 0 27px;
  margin-right: 0;
}
.country-dropdown::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #dddddd;
}

.select-country-con {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 14px 0 20px;
  cursor: pointer;
}

.select-country-con .country-placeholder {
  flex: 1;
  font-size: 16px;
  color: #1a2332;
}

.select-country-con i {
  font-size: 16px;
  color: #1a2332;
  transition: all 0.3s;
}

.country-arrow {
  transform: rotate(180deg);
}

.select-country-img {
  width: 34px;
  height: 20px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}

.select-country-name {
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-right: 6px;
  line-height: 20px;
  font-size: 18px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.country-popper {
  position: absolute;
  top: 84px;
  left: 0;
  width: 1000px;
  height: 300px;
  padding: 18px 5px 0px 0;
  margin-top: 0 !important;
  background: #ffffff;
  box-shadow: 0px -8px 20px 0px rgba(10, 33, 57, 0.24);
  border-radius: 12px;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.country-show-popper {
  width: 1178px;
  height: 378px;
  opacity: 1;
  z-index: 2001;
  pointer-events: all;
  transition: all 0.3s ease-in-out;
}
.country-popper-arrow,
.country-popper-arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.country-popper-arrow {
  left: 60px;
  top: -12px;
  border-width: 12px;
  border-top-width: 0;
  border-bottom-color: #ffffff;
}

.country-popper-arrow::after {
  content: "";
  border-width: 12px;
  border-bottom-color: #ffffff !important;
  filter: drop-shadow(0px -8px 20px 0px rgba(10, 33, 57, 0.24)) !important;
}

.country-popper-con {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.country-popper-con .state-con {
  width: 220px;
  height: calc(100% - 18px);
  flex-shrink: 0;
  border-right: 1px solid #dddddd;
  overflow: auto;
}

.country-popper-con .country-state-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 42px;
  padding: 0 20px;
  cursor: pointer;
}

.country-popper-con .country-state-item:not(:last-child) {
  margin-bottom: 8px;
}

.country-popper-con .country-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  font-size: 16px;
  color: #1a2332;
}

.country-popper-con .country-state-item.activeState {
  background: #f5f5f5;
}

.country-popper-con .country-state-item:hover .country-name,
.country-popper-con .country-state-item.activeState .country-name {
  color: #1290c9;
}
.country-popper-con .country-countryCount {
  width: 30px;
  font-size: 14px;
  color: #999999;
  text-align: right;
}

.country-popper-con .state-country-con {
  width: 953px;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-content: flex-start;
  padding-left: 20px;
  overflow: auto;
}

.country-popper-con .state-country-item {
  width: 222px;
  height: 56px;
  padding: 8px 10px;
  margin-bottom: 10px;
  background: #f5f5f5;
  border: 1px solid #f5f5f5;
  cursor: pointer;
}

.country-popper-con .state-country-item-con {
  display: flex;
  align-items: center;
  justify-content: start;
}

.country-popper-con .state-country-item:hover,
.country-popper-con .state-country-item.activeCountry {
  border-color: #1290c9;
}
.country-popper-con .state-country-item:not(:nth-child(4n)) {
  margin-right: 10px;
}

.country-popper-con .state-country-item img {
  width: 56px;
  height: 34px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}

.country-popper-con .state-country-info {
  flex: 1;
  overflow: hidden;
}

.country-popper-con .state-country-name {
  line-height: 20px;
  margin-bottom: 4px;
  font-size: 16px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.country-popper-con .state-country-companyCount {
  font-size: 14px;
  color: #999999;
  line-height: 1;
}
.head_swi_keyword {
  position: relative;
  margin-right: 20px;
}
.head_swi_keyword /deep/ .el-switch {
  height: 40px;
  line-height: 40px;
}
.head_swi_keyword /deep/ .el-switch__core {
  width: 100px !important;
  height: 40px;
  border-radius: 20px;
  border: none;
}
.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core {
  background: #1290c9;
}
.head_swi_keyword /deep/ .el-switch__core:after {
  top: 2px;
  left: 1px;
  width: 36px;
  height: 36px;
  background: #ffffff;
}
.head_swi_keyword /deep/ .el-switch.is-checked + .switch_txt {
  top: 50%;
  transform: translate(-80%, -50%);
  left: 50%;
}
.switch_txt {
  position: absolute;
  left: 40px;
  top: 5px;
  font-size: 14px;
  color: #ffffff;
  line-height: 14px;
}
.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
  margin-left: 0 !important;
  left: 63px !important;
}
@media (max-width: 1920px) {
  .new-home-search-text {
    font-size: 14px;
    line-height: 20px;
  }

  .new-home-title {
    width: calc(100% - 26px);
    height: 58px;
    line-height: 58px;
    padding-left: 14px;
    font-size: 22px;
    border-radius: 5px;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
  }

  .new-home-bottom-card {
    height: 235px;
    padding: 14px;
    border-radius: 8px;
  }

  .new-home-card-left {
    padding-left: 35px;
  }

  .new-home-card-left img {
    top: 74px;
    left: 10px;
    width: 15px;
    height: auto;
  }

  .new-home-card-left .slider-con {
    padding-top: 10px;
  }

  .new-home-card-left .slider-item {
    height: 18px;
    line-height: 18px;
    font-size: 12px;
  }

  .new-home-card-left .slider-item.active {
    font-size: 20px;
  }

  .new-home-card-left .slider-item:not(:last-child) {
    margin-bottom: 1px;
  }

  .new-home-card-middle {
    margin: 0 10px;
  }

  .new-home-middle-img {
    width: 468px;
    height: 266px;
    animation: scrollImg 15s linear infinite alternate;
  }

  .new-home-middle-text {
    padding: 20px 14px;
    font-size: 12px;
    line-height: 14px;
  }

  .new-home-card-right {
    width: 205px;
    padding: 26px 6px 0 6px;
    border-radius: 8px;
  }

  .new-home-right-img {
    width: 80px;
    height: 80px;
    padding: 2px;
    margin: 0 auto 10px auto;
  }

  .new-home-right-text {
    font-size: 12px;
    line-height: 14px;
  }

  .search-country-input >>> .el-input__inner {
    line-height: 46px;
    font-size: 14px;
    padding: 0 0 0 10px !important;
  }

  .select-country-con.trade_sel_pro,
  .search-country-input .trade_sel_pro >>> .el-input__inner {
    padding: 0 !important;
  }

  .search-country-btn {
    width: 110px;
    height: 50px;
    padding: 0 0 0 10px;
    font-size: 14px;
    border-radius: 0px 26px 26px 0px;
  }

  .search-country-btn i {
    margin-right: 5px;
    font-size: 26px;
  }

  .select-country-con {
    padding-left: 6px;
  }

  .page-top-con .select-country-con i {
    font-size: 16px;
  }
  .head_swi_keyword {
    margin-right: 15px;
  }
  .head_swi_keyword /deep/ .el-switch {
    height: 32px;
    line-height: 32px;
  }
  .head_swi_keyword /deep/ .el-switch__core {
    width: 90px !important;
    height: 32px;
    border-radius: 16px;
  }
  .head_swi_keyword /deep/ .el-switch__core:after {
    top: 1px;
    left: 1px;
    width: 30px;
    height: 30px;
  }
  .head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
    left: 59px !important;
  }
  .switch_txt {
    left: 40px;
    top: 5px;
    font-size: 12px;
    line-height: 12px;
  }

  .new-home-bottom {
    width: 1300px;
  }

  .search-country-input {
    padding: 0 14px 0 0;
  }

  .country-dropdown {
    width: 160px;
    min-width: 160px;
    border-radius: 20px 0 0 20px;
  }

  .country-dropdown::after {
    height: 22px;
  }

  .select-country-con {
    padding: 0 10px 0 15px;
  }

  .select-country-con .country-placeholder {
    font-size: 14px;
  }

  .select-country-img {
    width: 22px;
    height: 14px;
    margin-right: 4px;
  }

  .select-country-name {
    margin-right: 2px;
    line-height: 16px;
    font-size: 14px;
  }

  .country-popper {
    top: 58px;
    width: 750px;
    height: 200px;
    padding: 10px 3px 10px 0;
    border-radius: 4px;
  }

  .country-show-popper {
    width: 850px;
    height: 264px;
  }

  .country-popper-arrow {
    left: 35px;
    top: -6px;
    border-width: 6px;
    border-top-width: 0;
    border-bottom-color: #ffffff;
  }

  .country-popper-arrow::after {
    border-width: 8px;
  }

  .country-popper-con .state-con {
    width: 218px;
    height: 100%;
  }

  .country-popper-con .country-state-item {
    height: 40px;
    padding: 0 14px;
  }

  .country-popper-con .country-state-item:not(:last-child) {
    margin-bottom: 0px;
  }

  .country-popper-con .country-name {
    line-height: 14px;
    font-size: 14px;
  }

  .country-popper-con .country-countryCount {
    flex-shrink: 0;
    width: 20px;
    font-size: 12px;
  }

  .country-popper-con .state-country-con {
    width: 640px;
    padding-left: 10px;
  }

  .country-popper-con .state-country-item {
    width: 148px;
    height: 40px;
    padding: 4px 6px;
    margin-bottom: 6px;
  }

  .country-popper-con .state-country-item:not(:nth-child(4n)) {
    margin-right: 6px;
  }

  .country-popper-con .state-country-item img {
    width: 38px;
    height: 22px;
    margin-right: 4px;
  }

  .country-popper-con .state-country-name {
    line-height: 14px;
    margin-bottom: 2px;
    font-size: 14px;
  }

  .country-popper-con .state-country-companyCount {
    font-size: 12px;
  }
}
@media screen and (max-width: 1439px) {
  .new-home-bottom {
    width: 1100px !important;
  }
}
</style>
